<template>
  <div class="content">
    <div>
      <img v-if="+$db.get('Hide_Company_Info') !== 1" src="../../../static/img/icon2.png" style="width: 250px;height: 45px"/>
    </div>
    <span class="title1" :class="+$db.get('Hide_Company_Info') === 1 ? 'ft30' : ''">{{ +$db.get('Hide_Company_Info') === 1 ? '妊娠期高血压与子痫前期筛查防控中心项目 （ChiPERM III）' : '智慧妇幼管理系统AC-IMCMS'}}</span>
    <span class="title2">Intelligent maternal and child management system</span>
    <span class="title3">AI+数字化——数据赋能  智慧妇幼</span>
    <div>
      <a-row :gutter="20" style="margin: 50px 0 20px">
        <a-col span="4">
          <img src="../../../static/img/icon3.png" style="width: 40px;height: 40px"/>
        </a-col>
        <a-col span="4">
          <img src="../../../static/img/icon4.png" style="width: 40px;height: 40px"/>
        </a-col>
        <a-col span="4">
          <img src="../../../static/img/icon5.png" style="width: 40px;height: 40px"/>
        </a-col>
      </a-row>
      <a-row :gutter="40">
        <a-col span="4" class="border-left">
          <div class="subtitle">全孕期风险管理</div>
          <div class="subcontent">建立孕产妇“全孕期”管理体系，降低不良妊娠结局</div>
        </a-col>
        <a-col span="4" class="border-left">
          <div class="subtitle">疾病风险评估</div>
          <div class="subcontent">系统接入AI风险评估接口，提高诊断效率</div>
        </a-col>
        <a-col span="4" class="border-left">
          <div class="subtitle">智能数据分析</div>
          <div class="subcontent">多维度、智能化、可视化数据分析平台，助力医学科研</div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Info',
  components: {},
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
  .content {
    text-align: start;
    display: flex;
    flex-direction: column;
    color: #fff;
  }
  .title1 {
    font-weight: 400;
    font-size: 42px;
    line-height: 63px;
  }
  .title2 {
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    margin-top: 20px;
  }
  .title3 {
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    margin-top: 40px;
  }
  .subtitle {
    font-weight: 400;
    font-size: 16px;
    margin-bottom: 10px;
  }
  .subcontent {
    color: rgba(255, 255, 255, 0.8);
  }
  .border-left {
    font-weight: 400;
    font-size: 11px;
    padding-left: 10px;
    height: 80px;
  }
  .border-left + .border-left {
    border-left: 1px solid #fff;
  }
  .ft30 {
    font-size: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/views/login/Info.vue